// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.55025291,15 L7.13603926,13.5857859 L10.6715727,10.0502529 L7.1360383,6.51471853 L8.55025291,5.10050488 L13.5,10.0502529 L8.55025291,15 Z M0,10 C0,4.47715187 4.47715378,0 10,0 C15.5228486,0 20,4.47715378 20,10 C20,15.5228486 15.5228467,20 10,20 C4.47715187,20 0,15.5228467 0,10 C0,6.31810125 0,6.31810125 0,10 Z M2,10 C2,5.58172131 5.58172321,2 10,2 C14.4182792,2 18,5.58172321 18,10 C18,14.4182792 14.4182773,18 10,18 C5.58172131,18 2,14.4182773 2,10 C2,7.05448087 2,7.05448087 2,10 Z"
            />
        </svg>
    );
};

export default React.memo(ChevronRight);
